module.exports = __webpack_public_path__ + "Roboto-Regular.4e6f9d21a0212ad04b36.svg";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2/src/assets/fonts/Roboto-Regular.svg
// module id = ../../../../../src/assets/fonts/Roboto-Regular.svg
// module chunks = main